export const OtherConstants = {
  ShowedModalCss: 'dialog-visible',
  QueryIdsSeparator: ',',
  TimeZone: 'Europe/Prague', // the vehicles' zone: every day edge and displayed time follows it, not the viewer
  DefaultSelectedDaysFrom: 6,
  MaxCameraRangeMinutes: 15,
  CameraStreamTimeout: 120, // in seconds
  VrnPattern: /^[^:;,]*$/, // the API rejects a VRN with a colon, semicolon or comma
};
